import type { MachineSwing } from 'src/Types/SwingTypes'
import { AssetType } from 'src/Types/AssetTypes'

/** Checks if a MachineSwing belongs to a derailer machine by testing if switchBaneDataId contains "-SSP-". */
export const isDerailerSwing = (swing: MachineSwing): boolean => !!swing.switchBaneDataId && /-SSP-/.test(swing.switchBaneDataId)

/**
 * Determines asset type from a MachineSwing by checking if the switchBaneDataId contains "-SSP-"
 * which indicates a Sporsperre/Derailer machine.
 */
export const getAssetTypeFromSwing = (swing: MachineSwing): AssetType =>
  isDerailerSwing(swing) ? AssetType.DerailerMachine : AssetType.SwitchPointMachine
